// src/components/SaaS/ComedianDetailPage.js
import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { fetchUserProfile, fetchComedianDetail } from '../../services/api';


const ComedianDetailPage = () => {
  const { id } = useParams();

  const [userProfile, setUserProfile] = useState(null);
  const [comedian, setComedian] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const [sidebarCollapsed, setSidebarCollapsed] = useState(
      () => JSON.parse(localStorage.getItem('sidebarCollapsed')) || false
    );
  
    useEffect(() => {
      localStorage.setItem('sidebarCollapsed', JSON.stringify(sidebarCollapsed));
    }, [sidebarCollapsed]);

  const scrollRef = useRef(null);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
  const el = scrollRef.current;
  if (!el) return;

  const { scrollLeft, scrollWidth, clientWidth } = el;

  setCanScrollLeft(scrollLeft > 0);
  setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
  };


  useEffect(() => {
    const token = localStorage.getItem('authToken');

    const loadUserProfile = async () => {
      try {
        const profile = await fetchUserProfile(token);
        setUserProfile(profile);
      } catch (err) {
        console.error(err);
      }
    };

    const loadComedian = async () => {
      try {
        const data = await fetchComedianDetail(id);
        setComedian(data);

        // Auto-select first special
        if (data.specials?.length > 0) {
          setSelectedVideo(data.specials[0]);
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadUserProfile();
    loadComedian();
  }, [id]);

 



  // Convert Google Drive link → embed
  const getEmbedUrl = (url) => {
    const match = url.match(/\/d\/(.*?)\//);
    return match
      ? `https://drive.google.com/file/d/${match[1]}/preview`
      : url;
  };

  if (!comedian) return <div className="text-center mt-5">Loading...</div>;

  return (
    <div className="dashboard-background">
      <div className="container-fluid">
        <div className="d-flex">
          <Sidebar userProfile={userProfile}
            isCollapsed={sidebarCollapsed}
            setIsCollapsed={setSidebarCollapsed}
          />

          <main className="flex-grow-1 px-4"
            style={{
              minHeight: '100vh',
              marginLeft: sidebarCollapsed ? '60px' : '220px',
              minWidth: 0 // ✅ prevents ANY child from breaking layout
            }}
          >

            {/* HEADER */}
            <div className="text-center mb-4">
              <img
                src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736174973/image-removebg-preview_1_rez4gn.png"
                alt="Logo"
                style={{ width: '100px', height: '100px' }}
              />
              <h1 className="fw-bold d-inline mb-0">
                {comedian.name} Specials
              </h1>
            </div>

            {/* HEADER */}
            <div className="d-flex align-items-center gap-4 mb-4">
              <img
                src={comedian.image}
                alt={comedian.name}
                style={{
                  width: '120px',
                  height: '120px',
                  objectFit: 'cover',
                  borderRadius: '12px'
                }}
              />

              <div>
                <h2 className="fw-bold">{comedian.name}</h2>
                <p className="text-muted mb-0">{comedian.bio}</p>
              </div>
            </div>

            {/* SPECIALS PILLS WRAPPER */}
            <div style={{ position: 'relative', marginBottom: '20px' }}>

              {/* LEFT ARROW */}
              <button
                onClick={() => {
                  scrollRef.current.scrollBy({ left: -200, behavior: 'smooth' });
                }}
                style={{
                  position: 'absolute',
                  left: '6px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '34px',
                  height: '34px',
                  borderRadius: '50%',
                  border: 'none',
                  background: 'rgba(0,0,0,0.6)',
                  color: '#fff',
                  cursor: 'pointer',
                  zIndex: 10,
                  opacity: canScrollLeft ? 1 : 0,
                  pointerEvents: canScrollLeft ? 'auto' : 'none',
                  transition: 'opacity 0.2s ease',
                  fontWeight: '900'
                }}
                onMouseEnter={(e) => e.target.style.background = 'rgba(0,0,0,0.8)'}
                onMouseLeave={(e) => e.target.style.background = 'rgba(0,0,0,0.6)'}
              >
                ❮
              </button>

              {/* SPECIALS PILLS */}
              <div
                ref={scrollRef}
                onScroll={(e) => {
                  const el = e.currentTarget;
                  const { scrollLeft, scrollWidth, clientWidth } = el;

                  setCanScrollLeft(scrollLeft > 0);
                  setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
                }}

                style={{
                display: 'flex',
                gap: '15px',
                overflowX: 'auto',
                overflowY: 'hidden', // 👈 prevents vertical scrollbar
                marginBottom: '20px',

                minWidth: 0,          // ✅ CRITICAL FIX
                maxWidth: '100%',     // ✅ prevents page expansion

                scrollbarWidth: 'none', // 👈 Firefox
                msOverflowStyle: 'none' // 👈 IE/Edge
              }}
              className="hide-scrollbar"
            >
              {comedian.specials.map((special) => {
                const isActive = selectedVideo?.id === special.id;

                return (
                  <button
                    key={special.id}
                    onClick={() => setSelectedVideo(special)}
                    onMouseEnter={(e) => {
                      if (!isActive) {
                        e.target.style.backgroundColor = '#e5e7eb';
                        e.target.style.transform = 'scale(1.05)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive) {
                        e.target.style.backgroundColor = '#f3f4f6';
                        e.target.style.transform = 'scale(1)';
                      }
                    }}
                    style={{
                      padding: '10px 26px',
                      borderRadius: '999px',
                      border: 'none',
                      cursor: 'pointer',
                      whiteSpace: 'nowrap',
                      fontWeight: 'bold',
                      backgroundColor: isActive ? '#111827' : '#f3f4f6',
                      color: isActive ? '#fff' : '#111827',
                      transition: 'all 0.2s ease',
                      transformOrigin: 'center' // 👈 prevents weird growth direction
                    }}
                  >
                    {special.title}
                  </button>
                );
              })}
              </div>

              {/* RIGHT ARROW */}
              <button
                onClick={() => {
                  scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' });
                }}
                style={{
                  position: 'absolute',
                  right: '6px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '34px',
                  height: '34px',
                  borderRadius: '50%',
                  border: 'none',
                  background: 'rgba(0,0,0,0.6)',
                  color: '#fff',
                  cursor: 'pointer',
                  zIndex: 10,
                  opacity: canScrollRight ? 1 : 0,
                  pointerEvents: canScrollRight ? 'auto' : 'none',
                  transition: 'opacity 0.2s ease',
                  fontWeight: '900'
                }}
                onMouseEnter={(e) => e.target.style.background = 'rgba(0,0,0,0.8)'}
                onMouseLeave={(e) => e.target.style.background = 'rgba(0,0,0,0.6)'}
              >
                ❯
              </button>

            </div>

            {/* VIDEO PLAYER */}
            {selectedVideo && (
              <div className="mb-4">
                <h5 className="mt-3 fw-bold">{selectedVideo.title}</h5>
                <iframe
                  src={getEmbedUrl(selectedVideo.description)}
                  width="100%"
                  height="500"
                  allow="autoplay"
                  allowFullScreen
                  title={selectedVideo.title}
                  style={{ borderRadius: '12px', border: 'none' }}
                ></iframe>

              </div>
            )}

          </main>
        </div>
      </div>
    </div>
  );
};

export default ComedianDetailPage;